import { render, staticRenderFns } from "./item.vue?vue&type=template&id=339c22ae&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339c22ae')) {
      api.createRecord('339c22ae', component.options)
    } else {
      api.reload('339c22ae', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=339c22ae&", function () {
      api.rerender('339c22ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/desempenho/item.vue"
export default component.exports